import { render, staticRenderFns } from "./PlaceBetButtonFreeWager.vue?vue&type=template&id=3ba518ac&"
import script from "./PlaceBetButtonFreeWager.vue?vue&type=script&lang=js&"
export * from "./PlaceBetButtonFreeWager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports